import elrond from "assets/img/elrond.svg";
import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  let headerText = "";
  const ENV = process.env.REACT_APP_ETH_PROVIDER;
  switch (ENV) {
    case "ropsten":
      headerText = "Ropsten Testnet Network";
      break;
    case "live":
      headerText = "Main Ethereum Network";
      break;

    default: headerText = "Development Ethereum Network";
  }
  return (
    <header className="staking-header flex-shrink-0">
      <div className="container">
          <img
            src={elrond}
            alt="Elrond"
          />
          <span>Prestaking</span>
          <p className="network">{headerText}</p>
      </div>
    </header>
  );
};

export default Header;
